export const CATEGORIES_WITH_SUBCATEGORIES = [
  {
    name: 'שיעורים והרצאות',
    subcategories: [
      'הרצאות',
      'שיעורים',
      'קורסים',
      'מרצים להתוועדויות',
      'סיורים לימודיים',
      'טיולים וסיורים לקבוצות',
    ],
  },
  {
    name: 'מופעים והפעלות',
    subcategories: [
      'סדנאות',
      'הפעלות',
      'מופעים',
      'מוזיקאים',
      'משחקי למידה וחברה',
    ],
  },
  {
    name: 'שיווק, פרסום ומיתוג',
    subcategories: [
      'שיווק דיגיטלי',
      'ניהול מדיה',
      'כתיבה ועריכת תוכן',
      'עיצוב גרפי (פליירים, לוגואים)',
      'צילום ועריכת וידאו',
      'הדפסה',
      'שילוט',
    ],
  },
  {
    name: 'ניהול פיננסי ועסקי',
    subcategories: [
      'הנהלת חשבונות',
      'ראיית חשבון',
      'ייעוץ פיננסי ועסקי',
      'ייעוץ מס',
      'גיוס כספים',
      'פיתוח עסקי וארגוני',
      'תכנון תקציבים',
      'ייעוץ משפטי ועריכת דין',
      'שירותי מזכירות (ניהול יומן, עוזר אישי, טלפניות)',
    ],
  },
  {
    name: 'לוגיסטיקה ותפעול',
    subcategories: ['משלוחים והסעות', 'תחזוקת מבנים', 'ציוד', 'שירותי ניקיון'],
  },
  {
    name: 'ריהוט וציוד מוסדי',
    subcategories: [
      'ריהוט לבתי כנסת',
      'ריהוט לגנים ובתי ספר',
      'ציוד לגנים וקייטנות',
      'ספרי קודש וספריות',
    ],
  },
  {
    name: 'הפקת אירועים וציוד',
    subcategories: [
      'הפקה וניהול אירועים',
      'הנחיית אירועים',
      'ציוד הגברה ותאורה',
      'מסכים ואביזרים ויזואליים',
      'מחיצות ושילוט',
      'השכרת ריהוט (שולחנות, כיסאות)',
      'אבטחה ושמירה',
      'דוכנים ופופ-אפים',
      'ציוד טכני (מקרנים, מיקרופונים)',
      'עיצוב חלל ובמות',
    ],
  },
  {
    name: 'קייטרינג',
    subcategories: [
      'קייטרינג חלבי',
      'קייטרינג בשרי',
      'מגשי אירוח',
      'מאפים וקינוחים',
    ],
  },
  {
    name: 'אחר',
    subcategories: [],
  },
];

export const LOCATIONS = ["כל הארץ", "צפון", "דרום", "מרכז", "אזור ירושלים", "זום"];

export const TARGET_AUDIENCES = ["כללי", "מסורתי", "דתי", "חרדי", "נשים", "גברים", "מבוגרים - הגיל השלישי", "נוער", "ילדים"];

export const PUBLISHER_EXPLANATION_TEXT = `ברוכים הבאים ללוח חב"ד!
הלוח שלנו מציע פרסום ממוקד, חכם וישיר לקהל שליחי חב"ד בישראל, דרך האפליקציה הרשמית של השליחים.`;

export const PUBLISHER_INFO_LINK = 'https://drive.google.com/file/d/1MeSiUswLJEVQAY6SVgu_Ixf7xp_sl9ui/view?usp=drive_link';

export const SHALIACH_EXPLANATION_TEXT = `שליח יקר!
אם יש לכם עסק, מוצרים או שירותים שיכולים להועיל לקהילת השלוחים/שלוחות ולספק פתרונות לצרכי השליחות, תוכלו לפרסם מודעה בלוח ולהציע אותם לכולם.
בתקופת ההשקה של הלוח, השירות ניתן ללא תשלום וללא מגבלת זמן פרסום. השירות מיועד באופן בלעדי לשלוחים, ואין להשתמש בו כדי לפרסם מודעות עבור גורמים עסקיים אחרים.
בהצלחה!`;

/** טקסט להפניה של מקורב/חבר שאינו שליח – מוצג רק בדף שליח */
export const SHALIACH_REFERRAL_LINE_1 = 'יש לכם מקורב/חבר שאינו שליח ורוצה לפרסם באתר?';
export const SHALIACH_REFERRAL_LINE_2_PREFIX = 'תפנו אותו אלינו 053-3753-331 או ב';

/** נתיב להרשמת מפרסם (לא שליח) – לשימוש עם בסיס הדומיין מהסביבה */
export const PUBLISHER_SUBMIT_PATH = '/business-ads/submit/publisher';

export const SHALIACH_REGULATIONS_LINK = 'https://drive.google.com/file/d/1TjxF2GFm-lQyIwla4ud-IcJ16mBYuW3u/view?usp=drive_link';

export const PUBLISHER_REGULATIONS = `תקנון שימוש למפרסמים
במאגר ספקים ונותני שירותים לבית חב"ד באפליקציית השלוחים

כללי
1. תקנון זה מגדיר את תנאי השימוש והפרסום במערכת המודעות של אפליקציית השלוחים (להלן: "המערכת" או "האפליקציה").
2. המערכת מאפשרת לעסקים ולנותני שירותים לפרסם את שירותיהם לקהל השלוחים, לרבות שלוחי חב"ד, שלוחות חב"ד ועובדי בתי חב"ד, דרך מודעות בתשלום.
3. השימוש ברכיב זה ובשירותי הפרסום מהווה הסכמה מלאה מצד המפרסם לתנאי התקנון במלואם.

כללי התנהלות ותוכן מודעות
4. המפרסם רשאי לפרסם אך ורק שירותים או מוצרים הרלבנטיים לפעילות אופיינית בבית חב"ד ובמוסדות הקשורים אליו - כבית כנסת, מקווה טהרה, מעונות יום, גנים, בתי ספר ומוסדות רווחה.
5. אין לפרסם תוכן שקרי, מטעה, לא אמין או לא בדוק. חובה להקפיד על שקיפות, אמינות והגינות בפרסום, בהצעת השירות ובתנאים המוצגים בפרסומים.
6. יש להקפיד לפרסם תוכן הולם לערכים ולצביון קהל היעד.

מחירים ותנאי תשלום
7. עלות פרסום באפליקציה מתומחרת עבור כל מודעה בנפרד על פי משך זמן הופעת המודעה, לפי הפירוט הבא:

12 חודשים: 120 ₪ לחודש, חודשיים מתנת הצטרפות – סה״כ 1,200 ₪ + מע״מ
6 חודשים: 150 ₪ לחודש, חודש מתנת הצטרפות – סה״כ 750 ₪ + מע״מ
3 חודשים: 180 ₪ לחודש – סה״כ 540 ₪ + מע״מ

כל הסכומים הנקובים ייגבו בתוספת מע"מ.
8. התשלום יבוצע במערכת סליקת אשראי, בפריסת תשלומים מקסימלית של 5 תשלומים חודשיים, בכפוף לתנאים ולמדיניות חברת האשראי.
9. במשך התקופה שנבחרה המודעה תוצג באפליקציה על פי מיקומה הרלבנטי במאגר הפרסומים, וכן בהופעות רנדומליות במסך המרכזי של לוח הפרסומים, ללא התערבות ידנית של המערכת.
10. מחירי הפרסום קבועים ולא משתנים על פי מידת חשיפה, ביצוע עסקאות או אפקטיביות הפרסום.
11. המערכת רשאית בכל עת לשנות על פי שיקול דעתה הבלעדי את התנאים המסחריים המנויים לעיל מעת השינוי ולהבא.

אחריות
12. המערכת אינה אחראית על טיב השירותים או המוצרים שיסופקו על ידי המפרסם, איכותם או אמינותם, ולא על תוכן המודעות או על מימושן בפועל.
13. המערכת אינה צד לעסקאות שיבוצעו בין מפרסם לבין משתמש באפליקציה או לבין כל גורם אחר, ולא תישא בכל אחריות לנזקים ישירים או עקיפים שייגרמו בשל ביצוע עסקה, ביטול עסקה, או כל התקשרות שנעשתה בעקבות הפרסום.

שימוש במידע
14. שימוש במערכת מהווה הסכמה מצד המפרסם לשימוש בפרטי המודעה ובפרטי הקשר של המפרסם, לרבות תוכן, שם העסק, פרטי קשר ודפוסי התקשרות – לצרכי פרסום עתידי, הצעות ערך למשתמשים, למפרסם עצמו ולמפרסמים אחרים ועוד.

הרשאה לפרסום והפסקת שירות
15. המערכת אינה מחויבת לאשר כל פרסום, ורשאית לדרוש ביצוע תיקוני תוכן וגרפיקה בפרסום או לדחות פרסום. אישור פרסום כל מודעה נתון לשיקול דעת בלעדי של מנהלי המערכת או מי שהוסמכו לכך על ידיו לעניין זה.
16. המערכת שומרת לעצמה את הזכות להסיר מודעה או להשעות מפרסם משימוש במערכת במקרים של הפרת תנאי התקנון, פרסום תוכן בלתי הולם, או תלונות חוזרות מצד משתמשים, וזאת ללא כל חובה בפיצוי כספי כלפי המפרסם.
17. המפרסם רשאי לבקש הסרה של המודעה בעיתוי מוקדם ממועד תפוגת הפרסום המוסכם. במקרה כזה לא יינתן למפרסם החזר כספי, אלא אם הוסכם אחרת.

סמכות שיפוט
18. על תקנון זה יחולו דיני מדינת ישראל בלבד, וכל מחלוקת תתברר אך ורק בבית המשפט המוסמך לכך על פי בחירת המערכת.

ברכישת השירות אני מאשר כי קראתי את תנאי השימוש, הסכמתי להם, ואני מתחייב לפעול בהתאם להם.`;
